import React, { useContext, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Button } from "semantic-ui-react";
import TextInput from "../../app/common/form/TextInput";
import { toast } from "react-toastify";
import {
  combineValidators,
  composeValidators,
  isRequired,
  hasLengthGreaterThan,
  hasLengthLessThan,
  matchesPattern,
} from "revalidate";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../app/stores/rootStore";

const validate = combineValidators({
  Name: composeValidators(
    isRequired({ message: "El Nombre es obligatorio" }),
    matchesPattern(/^[A-zÀ-ÿ \-]*$/)({
      message:
        "Solo se permiten caracteres alfanuméricos",
    }),
    hasLengthLessThan(65)({
      message: "El Nombre debe tener máximo 64 caracteres",
    }),
    hasLengthGreaterThan(1)({
      message: "El Nombre debe tener al menos 2 caracteres",
    }),
  )(),
  LastName: composeValidators(
    isRequired({ message: "El Apellido es obligatorio" }),
    matchesPattern(/^[A-zÀ-ÿ \-]*$/)({
      message:
        "Solo se permiten caracteres alfanumérico",
    }),
    hasLengthLessThan(65)({
      message: "El Apellido debe tener máximo 64 caracteres",
    }),
    hasLengthGreaterThan(1)({
      message: "El Apellido debe tener al menos 2 caracteres",
    }),
  )(),
  Phone: composeValidators(
    isRequired({ message: "El Teléfono es obligatorio" }),
    matchesPattern(/^[a-zA-Z0-9\.()-\\]*$/)({
      message:
        "Teléfono no válido. Contiene espacios o caracteres especiales diferente a: ( ) - . \\",
    }),
    hasLengthGreaterThan(6)({
      message: "El Teléfono debe tener al menos 7 caracteres",
    }),
    hasLengthLessThan(33)({
      message: "El Teléfono debe tener máximo 32 caracteres",
    })
  )(),
  Email: composeValidators(
    isRequired({ message: "El Email es obligatorio" }),
    matchesPattern(/^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/)({
      message: "Por favor digite un Email valido",
    }),
    hasLengthLessThan(257)({
      message: "El Email debe tener máximo 256 caracteres",
    }),
    hasLengthGreaterThan(5)({
      message: "El Email debe tener al menos 6 caracteres",
    }),
  )(),
});

const EditUserForm = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { user, editUser } = rootStore.userStore;
  const { loading } = rootStore.buttonLoadingStore;

  const [editInfoForm] = useState({
    Username: user?.username,
    Name: user?.name,
    LastName: user?.lastName,
    Phone: user?.phone,
    Email: user?.email,
  });

  const handleFinalFormSubmit = (values: any) => {
    if (
      values.Email !== editInfoForm.Email ||
      values.Name !== editInfoForm.Name ||
      values.LastName !== editInfoForm.LastName ||
      values.Phone !== editInfoForm.Phone
    ) {
      values.Name = values.Name.trim();
      values.LastName = values.LastName.trim();
      values.Email = values.Email.trim();
      values.Phone = values.Phone.trim();
      editUser(user?.id, values);
    } else toast.error("No ha hecho ningún cambio");
  };
  return (
    <div className="modalContent">
      <FinalForm
        validate={validate}
        initialValues={editInfoForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <label>Usuario de acceso</label>
              <Field
                name="Username"
                value={editInfoForm.Username}
                disabled={true}
                component={TextInput}
              />
              <label>Nombres</label>
              <Field
                name="Name"
                value={editInfoForm.Name}
                component={TextInput}
              />
              <label>Apellidos</label>
              <Field
                name="LastName"
                value={editInfoForm.LastName}
                component={TextInput}
              />
              <label>Teléfono</label>
              <Field
                name="Phone"
                value={editInfoForm.Phone}
                component={TextInput}
              />
              <label>Mail notificaciones</label>
              <Field
                name="Email"
                value={editInfoForm.Email}
                component={TextInput}
              />
              <Button
                loading={loading}
                disabled={loading}
                className="ui primary button"
                color="blue"
                type="submit"
                content="Guardar"
              />
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(EditUserForm);
